import { Typography } from '@mui/material';
import { theme } from '../../../theme';
import FaqTable from './FaqTable';
import { ThemeProvider } from '@mui/material/styles';

const FaqList = () => {
  return (
    <ThemeProvider theme={theme}>
      <Typography variant="h5" fontWeight="bold" mb={2}>
        Manage FAQ
      </Typography>
      <FaqTable />
    </ThemeProvider>
  );
};

export default FaqList;
